export const filterOptions = [
  { label: "1 Week", value: "week" },
  { label: "1 Month", value: "month" },
  { label: "3 Months", value: "3months" },
  { label: "6 Months", value: "6months" },
  { label: "1 Year", value: "year" },
];
